import axios from 'axios';
import { put, takeLatest, takeEvery } from 'redux-saga/effects';

function* fetchNewestRequests(action) {
    try {
        const response = yield axios.get('/api/requests/newest');
 
        yield put({ type: 'SET_NEWEST_REQUESTS', payload: response.data });
    } catch (error) {
        console.log('Error fetching requests', error);
    }
}
function* requestNewestSaga(){
    yield takeEvery('FETCH_NEWEST_REQUESTS', fetchNewestRequests);
}
export default requestNewestSaga;